import { useState, useMemo } from "react";
import { useLatest } from "../../../hooks";
import { fetchServiceOptions } from "../utils";

export const useServiceOptions = (filter) => {
  const [options, setOptions] = useState();
  useLatest(
    async (signal) => {
      setOptions(null);
      setOptions(await fetchServiceOptions(signal, filter));
    },
    [filter],
  );

  return useMemo(
    () => ({ options: options ?? [], loading: options == null }),
    [options],
  );
};
